/**
 * Theme styles for AddressDaDataField: same look as MuiOutlinedInput (root) and MuiMenu (dropdown).
 * Used by AddressDaDataField.js via styled(Box) with theme.components.AddressDaDataField.
 */
import { alpha } from '@mui/material/styles';
import { gray, brand } from '../themePrimitives';

/* eslint-disable import/prefer-default-export */
export const addressDaDataCustomizations = {
  AddressDaDataField: {
    styleOverrides: {
      root: ({ theme }) => {
        const t = theme.vars || theme;
        return {
          // Same as MuiOutlinedInput.root (inputs.js)
          padding: '8px 12px',
          color: t.palette.text.primary,
          borderRadius: t.shape.borderRadius,
          border: `1px solid ${t.palette.divider}`,
          backgroundColor: t.palette.background.default,
          transition: 'border 120ms ease-in',
          minHeight: '2.5rem',
          boxSizing: 'border-box',
          '&:hover': {
            borderColor: gray[400],
          },
          '&:focus-within': {
            outline: `3px solid ${alpha(brand[500], 0.5)}`,
            borderColor: brand[400],
          },
          '&[data-error="true"]': {
            borderColor: theme.palette.error.main,
          },
          '&[data-error="true"]:focus-within': {
            borderColor: theme.palette.error.main,
          },
          ...theme.applyStyles('dark', {
            '&:hover': {
              borderColor: gray[500],
            },
          }),
          // Inner input: no own border/bg so wrapper provides outline and rounded corners
          '& .suggestions-input': {
            width: '100% !important',
            minHeight: 0,
            padding: '0 !important',
            fontSize: theme.typography.body1.fontSize,
            fontFamily: theme.typography.fontFamily,
            lineHeight: theme.typography.body1.lineHeight,
            letterSpacing: theme.typography.body1.letterSpacing,
            border: 'none !important',
            borderRadius: 0,
            backgroundColor: 'transparent !important',
            color: 'inherit',
            outline: 'none !important',
            boxShadow: 'none !important',
            '&::placeholder': { color: theme.palette.text.disabled, opacity: 1 },
            '&:focus': { outline: 'none !important' },
            '&:disabled': {
              opacity: 0.5,
              cursor: 'not-allowed',
            },
            '&.loading': { backgroundImage: 'none !important' },
          },
          '& .suggestions-wrapper': {
            zIndex: theme.zIndex.modal,
          },
          // Dropdown: same as MuiMenu paper (navigation.js)
          '& .suggestions-suggestions': {
            marginTop: 4,
            padding: theme.spacing(0.5, 0),
            borderRadius: theme.shape.borderRadius,
            border: `1px solid ${theme.palette.divider}`,
            background: 'hsl(0, 0%, 100%)',
            backgroundImage: 'none',
            boxShadow:
              'hsla(220, 30%, 5%, 0.07) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.07) 0px 8px 16px -5px',
            maxHeight: 280,
            overflow: 'auto',
            ...theme.applyStyles('dark', {
              background: gray[900],
              boxShadow:
                'hsla(220, 30%, 5%, 0.7) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.8) 0px 8px 16px -5px',
            }),
          },
          '& .suggestions-hint': {
            padding: theme.spacing(1, 2),
            ...theme.typography.caption,
            color: theme.palette.text.secondary,
          },
          '& .suggestions-suggestion': {
            padding: theme.spacing(1.5, 2),
            ...theme.typography.body1,
            color: theme.palette.text.primary,
            cursor: 'pointer',
          },
          '& .suggestions-suggestion:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '& .suggestions-selected, & .suggestions-selected:hover': {
            backgroundColor: alpha(theme.palette.action.selected, 0.3),
          },
          '& .suggestions-value': { color: 'inherit' },
          '& .suggestions-subtext': {
            color: theme.palette.text.secondary,
            ...theme.typography.caption,
          },
        };
      },
    },
  },
};
